<template>
  <section class="support-nightkill">
    <transition name="fade" appear>
      <h2>Support NightKill</h2>
    </transition>

    <div class="merch-section load-hidden">
      <img
        src="/media/photos/merch/surviveMerch.webp"
        alt="NightKill CD and T-shirt"
        class="survive-img"
      />

      <div class="info">
        <p>
          You can grab our official CD <strong>worldwide</strong> via our
          label<br />
          <a
            href="https://alone.gr/shop/product/nightkill-survive-the-night-cd/"
            target="_blank"
            >ALONE Records</a
          >.
        </p>

        <p>
          If you're local, get in touch directly with the band to get the CD and
          the exclusive <strong>NightKill T-shirt</strong>!
        </p>

        <p>
          Our album <strong>Survive The Night</strong> is also available
          digitally:
        </p>

        <ul>
          <li>
            <a href="https://nightkill.bandcamp.com" target="_blank"
              >Bandcamp</a
            >
            (support us directly!)
          </li>
          <li>
            All major streaming platforms (Spotify, Apple Music, YouTube Music,
            etc.)
          </li>
        </ul>

        <p>Every purchase supports our journey — thank you!</p>
      </div>
    </div>
  </section>
</template>

<script>
import { useHead } from '@vueuse/head';
import ScrollReveal from 'scrollreveal';

export default {
  name: 'FanZone',
  mounted() {
    useHead({
      title: 'Merch | NightKill Official',
      meta: [
        {
          name: 'description',
          content:
            'Support NightKill — melodic heavy metal from Greece. Grab official merch, CDs, T-shirts and download our albums digitally via BandCamp',
        },
        {
          name: 'keywords',
          content:
            'NightKill merch, metal band Greece, band T-shirts, CD release, Survive The Night, Bandcamp, support metal band',
        },
        { property: 'og:title', content: 'Merch | NightKill Official' },
        {
          property: 'og:description',
          content:
            'Grab official NightKill merch — physical CDs, digital albums via Bandcamp, and exclusive T-shirts. Support melodic metal!',
        },
        {
          property: 'og:image',
          content: 'https://nightkill.gr/metadata/nightkill-logo.png',
        },
        { property: 'og:url', content: 'https://nightkill.gr/fanZone' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'NightKill Official' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Merch | NightKill Official' },
        {
          name: 'twitter:description',
          content:
            'Explore official merch from NightKill — melodic metal from Greece. CDs, shirts, and Bandcamp album downloads.',
        },
        {
          name: 'twitter:image',
          content: 'https://nightkill.gr/metadata/nightkill-logo.png',
        },
      ],
      link: [{ rel: 'canonical', href: 'https://nightkill.gr/fanZone' }],
    });

    this.$nextTick(() => {
      setTimeout(() => {
        const sr = ScrollReveal({
          origin: 'bottom',
          distance: '40px',
          duration: 800,
          easing: 'ease-in-out',
          cleanup: true,
        });

        sr.reveal('.survive-img');

        sr.reveal('.info p, .info ul', {
          delay: 200,
          interval: 150,
        });
      }, 100);
    });
  },
  beforeUnmount() {
    ScrollReveal().destroy();
  },
};
</script>

<style scoped>
.support-nightkill {
  padding: 0 1rem;
  max-width: 600px;
  margin: 0 auto;
  color: #ddd;
  text-align: center;
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: #2c3e50;
  margin-top: 0;
}

.merch-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
}

.survive-img {
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.5);
}

.info {
  font-size: 1rem;
  line-height: 1.7;
  max-width: 700px;
}

.info a,
ul a {
  font-weight: bold;
  text-decoration: underline;
}

ul {
  list-style: disc;
  padding-left: 1.5rem;
  text-align: left;
  margin: 1rem auto;
  max-width: 500px;
  font-size: 1.2rem;
}

/* Fade transition for h2 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
